// Fixed guideline rates. Keep amounts numeric and each billing attribute separate.
// One-time charges have no frequency; recurring charges use monthly or annually.
export const BILLING_TYPE_LABELS = {
  recurring: "Recurring",
  one_time: "One-time",
};

export const BILLING_FREQUENCY_LABELS = {
  monthly: "Monthly",
  annually: "Annually",
};

export const GUIDELINE_TABS = [
  { id: "action-statuses", label: "Action Statuses" },
  { id: "monthly", label: "Monthly Fees" },
  { id: "aml", label: "AML Checks" },
  { id: "paraplanning", label: "Paraplanning" },
  { id: "website", label: "Website & Graphics" },
  { id: "technology", label: "Technology" },
];

export const DEFAULT_ACTION_STATUS_LABEL = "Take Action";
export const DEFAULT_ACTION_STATUS_ID = "take-action";
export const SMART_SEARCH_CHARGE_AMOUNT = 5.99;
export const SMART_SEARCH_CHECK_TYPE = "Non-subsidised";

export const ACTION_STATUSES = [
  {
    id: DEFAULT_ACTION_STATUS_ID,
    label: DEFAULT_ACTION_STATUS_LABEL,
    color: "blue",
    meaning: "Default status for a flagged charge awaiting an action decision.",
  },
  {
    id: "no-action-required",
    label: "No Action Required",
    color: "crimson",
    meaning:
      "Amount differs this month, but acceptable temporarily. Expected to be flagged again next month if it recurs.",
  },
  {
    id: "approve-exception",
    label: "Approve Exception",
    color: "purple",
    meaning:
      "Amount differs from the guideline, but legitimate. This is an intentional ongoing exception and will not be flagged again next month.",
  },
  {
    id: "corrected-at-source",
    label: "Corrected at Source",
    color: "green",
    meaning:
      "Amount differed initially, but the underlying source has been corrected and the amount now reconciles.",
  },
  {
    id: "requires-review",
    label: "Requires Review",
    color: "red",
    meaning:
      "Amount differs from the expected guideline amount and is not yet resolved. This requires review and resolution.",
  },
];

export const MONTHLY_FEES = [
  {
    id: "fp",
    permission: "FP",
    billingType: "recurring",
    billingFrequency: "monthly",
    amount: 628.33,
  },
  {
    id: "ma",
    permission: "MA",
    billingType: "recurring",
    billingFrequency: "monthly",
    amount: 325,
  },
  {
    id: "gi-prot",
    permission: "GI/Prot",
    billingType: "recurring",
    billingFrequency: "monthly",
    amount: 325,
  },
  {
    id: "er",
    permission: "ER",
    billingType: "recurring",
    billingFrequency: "monthly",
    amount: 325,
  },
  {
    id: "nap",
    permission: "NAP",
    billingType: "recurring",
    billingFrequency: "monthly",
    amount: 0,
  },
  {
    id: "nsp",
    permission: "NSP",
    billingType: "recurring",
    billingFrequency: "monthly",
    amount: 0,
  },
];

export const WEBSITE_CHARGES = [
  {
    id: "design",
    category: "Website Design",
    description: "",
    billingType: "one_time",
    billingFrequency: null,
    fromDate: null,
    amount: 750,
  },
  {
    id: "hosting",
    category: "Website Hosting",
    description: "",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: "2026-05-01",
    amount: 20,
  },
  {
    id: "hosting",
    category: "Website Domain",
    description: "",
    billingType: "recurring",
    billingFrequency: "annually",
    fromDate: null,
    amount: null,
  },
];

export const TECHNOLOGY_CHARGES = [
  {
    id: "iq-engagement-assistant",
    category: "IQ Engagement Assistant",
    description: "",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 75,
  },
  {
    id: "knowledge-bank",
    category: "Knowledge Bank Subscription",
    description: "",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 16.8,
  },
  {
    id: "mbt",
    category: "MBT Subscription",
    description: "",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 16.79,
  },
  {
    id: "pension-fees",
    category: "Pension Fees",
    description: "",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 70,
  },
  {
    id: "io-mortgage",
    category: "IO Admin Licence",
    description: "Mortgage Adviser",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 60,
  },
  {
    id: "io-fp",
    category: "IO Admin Licence",
    description: "Financial Planning Adviser",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 120,
  },
  {
    id: "proceding",
    category: "ProCeding",
    description: "15+ bound",
    billingType: "one_time",
    billingFrequency: null,
    fromDate: null,
    hideInDropdown:true,
    amount: 1,
  },
  {
    id: "mailchimp",
    category: "Mailchimp Subscription",
    description: "",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    amount: 10,
  },
  {
    id: "email",
    category: "Email Licences",
    description: "Support + Security + Email (per licence)",
    billingType: "recurring",
    billingFrequency: "monthly",
    hideInDropdown:true,
    fromDate: null,
    amount: 15,
  },
  {
    id: "email-365",
    category: "Email Licences",
    description: "Support + Security + 365 (per licence)",
    billingType: "recurring",
    billingFrequency: "monthly",
    fromDate: null,
    hideInDropdown:true,
    amount: 30,
  },
];

export const MANUAL_ONE_TIME_CHARGE_TYPES = [
  {
    id: "smartsearch",
    label: "Smart Search",
    amount: SMART_SEARCH_CHARGE_AMOUNT,
    checkType: SMART_SEARCH_CHECK_TYPE,
  },
  { id: "redflag", label: "RedFlag" },
  { id: "loan-repayment", label: "Loan Repayment" },
  { id: "convention", label: "Convention" },
  { id: "peer-group-absence", label: "Peer Group Absence" },
  { id: "charity-ball", label: "Charity Ball" },
  { id: "other", label: "Other" },
];

// The recurring manual-charge form consumes this list directly, keeping the
// Technology choices, rates and billing schedule aligned with Guidelines.
export const TECHNOLOGY_MANUAL_CHARGE_TYPES = TECHNOLOGY_CHARGES
  .filter((charge) => !charge.hideInDropdown)
  .map((charge) => ({
    id: charge.id,
    label: [charge.category, charge.description].filter(Boolean).join(" - "),
    amount: charge.amount,
    billingType: charge.billingType,
    billingFrequency: charge.billingFrequency,
    fromDate: charge.fromDate,
  }));

export const MANUAL_CHARGE_TYPES = [
  ...MANUAL_ONE_TIME_CHARGE_TYPES,
  ...TECHNOLOGY_MANUAL_CHARGE_TYPES,
];

export const AML_CHECK_TYPES = [
  "Enhanced",
  "Standard",
  "Simple",
  "PEP & Sanctions",
];
// Charges for AML tools that are recorded manually.
export const OTHER_AML_TOOLS = [
  {
    id: "smartsearch",
    tool: "SmartSearch",
    checkType: SMART_SEARCH_CHECK_TYPE,
    amount: SMART_SEARCH_CHARGE_AMOUNT,
  },
  { id: "redflag", tool: "RedFlag", checkType: "", amount: null },
];

const amlChargeKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

const AML_GUIDELINE_CHARGE_KEYS = new Set(
  OTHER_AML_TOOLS.flatMap((charge) => [charge.id, charge.tool]).map(
    amlChargeKey,
  ),
);

export const isAmlGuidelineCharge = (charge = {}) =>
  [
    charge.chargeTypeId,
    charge.manualChargeTypeId,
    charge.chargeType,
    charge.manualChargeType,
  ].some((value) => AML_GUIDELINE_CHARGE_KEYS.has(amlChargeKey(value)));
